import { render, staticRenderFns } from "./ProjectStagesList.vue?vue&type=template&id=21308592&scoped=true&"
import script from "./ProjectStagesList.vue?vue&type=script&lang=js&"
export * from "./ProjectStagesList.vue?vue&type=script&lang=js&"
import style0 from "./ProjectStagesList.vue?vue&type=style&index=0&id=21308592&lang=scss&scoped=true&"
import style1 from "./ProjectStagesList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21308592",
  null
  
)

export default component.exports